__turbopack_context__.v({
  "columns": "DataInfo-module-scss-module__7RviTq__columns",
  "columnswrapper": "DataInfo-module-scss-module__7RviTq__columnswrapper",
});
